<template>
    <Head titulo="Servicios - Envío de Formulario" />
    <div class="hero-bloque-mascara">
        <div class="hero-bloque-mascara__img">
            <img src="/img/hero-bloque-img-mascara.png" alt="">
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-7">
                    <h1 class="hero-encabezado">{{ servicio.nombre }}</h1>
                    <div class="hero-etiquetas">
                        <span class="badge etiqueta-simple">Trámite en Línea</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-form-enviado">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-md-8 col-lg-6">
            <img loading="lazy" width="99" height="87" class="bloque-form-enviado__icono" src="/img/icono-hexagono-check-dorado.svg" alt="">
            <h1 class="bloque-form-enviado__encabezado">Enviaste el formulario de forma exitosa.</h1>
            <div class="bloque-form-enviado__info">
              <p>En breve nuestro personal se comunicará contigo al correo o teléfono que nos proporcionaste para continuar con el trámite. Gracias por confiar en el Gobierno de Santiago, Nuevo Léon.</p>
            </div>
            <Link :href="route('servicios')" class="boton-secundario boton-flecha">Regresar a Trámites y Servicios</Link>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
import { Link } from '@inertiajs/inertia-vue3'

export default {
    props: {
        servicio: Object,
    },
    components: {
        Link, Head
    },
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.boton-descarga,
.bloque-acordeon__item a {
    color: #333;
    text-decoration: none;
}

.gris {
    border-bottom: 1px solid #ddd;
}

.bloque-acordeon__link {
    cursor: pointer;
}

.bloque-acordeon__link:hover {
    color: rgba(0, 0, 0, 0.5);
}

.boton-descarga:hover {
    color: #000;
    text-decoration: none;
}
</style>
